module.exports = __webpack_public_path__ + "static/media/xiaomi_battery_2.e42b2494.jpg";